module.exports = __webpack_public_path__ + "static/footer-2e8b06776c1452547f400f28a9afd359.png";